import React, { useState, useEffect, useRef } from "react";
import { Plus, Trash2 } from "lucide-react";
import "./student-loan.scss";
import { Card, CardBody, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  activityEnd,
  activityStart,
} from "../../../redux/slices/trackActivitySlice";
import usePageTracking from "../../../hooks/usePageTracking";
import { calculatorAnalytics } from "../../../redux/slices/lifeinsuranceSlice";
import { sessionId } from "../../../redux/slices/cityComparisonSlice";

export default function StudentLoanCalculator() {
  const [loans, setLoans] = useState([
    { id: 1, interestRate: "", balance: "", minPayment: "", accountName: "" },
  ]);
  const [householdIncome, setHouseholdIncome] = useState("");
  const [extraPayment, setExtraPayment] = useState("");
  const [results, setResults] = useState(null);
  const dispatch = useDispatch();

  const debounceRef = useRef({});
  useEffect(() => {
    const payload = {
      page_name: "STUDENT_LOAN",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "STUDENT_LOAN",
        }),
      );
    };
  }, [dispatch]);
  usePageTracking("STUDENT_LOAN");

  

  const addLoan = () => {
    setLoans([
      ...loans,
      {
        id: Date.now(),
        interestRate: "",
        balance: "",
        minPayment: "",
        accountName: "",
      },
    ]);
  };

  const removeLoan = (id) => {
    if (loans.length > 1) {
      setLoans(loans.filter((loan) => loan.id !== id));
    }
  };

  // const updateLoan = (id, field, value) => {
  //   setLoans(
  //     loans.map((loan) =>
  //       loan.id === id ? { ...loan, [field]: value } : loan,
  //     ),
  //   );
  // };
  const buildLoanInputs = () => {
    const result = {};

    if (!Array.isArray(loans)) return result;

    loans.forEach((loan, index) => {
      result[loan] = {
        interest_rate: Number(loan.interestRate) || 0,
        balance: Number(loan.balance) || 0,
        min_payment: Number(loan.minPayment) || 0,
      };
    });

    return result;
  };
  const loansDebounceRef = useRef(null);
  const prevLoansRef = useRef([]);

  // useEffect(() => {
  //   const session_id = sessionStorage.getItem("comparison_session_id");
  //   if (!session_id || !Array.isArray(loans)) return;

  //   loans.forEach((loan, index) => {
  //     const prevLoan = prevLoansRef.current[index];

  //     const isComplete =
  //       loan.interestRate &&
  //       loan.balance &&
  //       loan.minPayment &&
  //       Number(loan.interestRate) > 0 &&
  //       Number(loan.balance) > 0 &&
  //       Number(loan.minPayment) > 0;

  //     const wasComplete =
  //       prevLoan &&
  //       prevLoan.interestRate &&
  //       prevLoan.balance &&
  //       prevLoan.minPayment;

  //     // ✅ trigger only when loan becomes complete
  //     if (isComplete && !wasComplete) {
  //       const payload = {
  //         loan_name: `loan_${index + 1}`,
  //         loan: {
  //           interest_rate: Number(loan.interestRate),
  //           balance: Number(loan.balance),
  //           min_payment: Number(loan.minPayment),
  //         },
  //       };

  //       if (loansDebounceRef.current) {
  //         clearTimeout(loansDebounceRef.current);
  //       }

  //       loansDebounceRef.current = setTimeout(() => {
  //         dispatch(
  //           calculatorAnalytics({
  //             calculator_type: "student_loan",
  //             event_type: "input_adjusted",
  //             session_id,
  //             timestamp: new Date().toISOString(),
  //             all_inputs: payload,
  //           })
  //         );
  //       }, 1000);
  //     }
  //   });

  //   prevLoansRef.current = loans;
  // }, [loans]);
 useEffect(() => {
  const session_id = sessionStorage.getItem("comparison_session_id");
  if (!session_id || !Array.isArray(loans)) return;

  loans.forEach((loan, index) => {
    const prevLoan = prevLoansRef.current[index];

    const isComplete =
      loan.interestRate &&
      loan.balance &&
      loan.minPayment &&
      Number(loan.interestRate) > 0 &&
      Number(loan.balance) > 0 &&
      Number(loan.minPayment) > 0;

    if (!isComplete) return;

    const hasChanged =
      !prevLoan ||
      prevLoan.interestRate !== loan.interestRate ||
      prevLoan.balance !== loan.balance ||
      prevLoan.minPayment !== loan.minPayment;

    if (hasChanged) {
      const payload = {
        interest_rate: Number(loan.interestRate),
        balance: Number(loan.balance),
        min_payment: Number(loan.minPayment),
      };

      if (loansDebounceRef.current) {
        clearTimeout(loansDebounceRef.current);
      }

      loansDebounceRef.current = setTimeout(() => {
        dispatch(
          calculatorAnalytics({
            calculator_type: "student_loan",
            event_type: "input_adjusted",
            loan_name: `loan_${index + 1}`, // ✅ outside all_inputs
            results_viewed: true,
            session_id,
            timestamp: new Date().toISOString(),
            all_inputs: payload,
          })
        );
      }, 1000);
    }
  });

  prevLoansRef.current = loans;
}, [loans]);

  // const updateLoan = (id, field, value) => {
  //   // Update state immediately
  //   setLoans((prevLoans) =>
  //     prevLoans.map((loan) =>
  //       loan.id === id ? { ...loan, [field]: value } : loan,
  //     ),
  //   );

  //   const session_id = sessionStorage.getItem("comparison_session_id");
  //   if (!session_id || value === "") return;

  //   const key = `${id}_${field}`;

  //   // Clear previous timer for this field
  //   if (debounceRef.current[key]) {
  //     clearTimeout(debounceRef.current[key]);
  //   }

  //   // Set new 2-second timer
  //   debounceRef.current[key] = setTimeout(() => {
  //     const isNumberField = ["interestRate", "balance", "minPayment"].includes(
  //       field,
  //     );
  //     dispatch(
  //       calculatorAnalytics({
  //         calculator_type: "student_loan",
  //         event_type: "input_adjusted",
  //         input_name: field.replace(/[A-Z]/g, (l) => `_${l.toLowerCase()}`),
  //         inputs: isNumberField ? parseFloat(value) : value.trim(),
  //         session_id,
  //         timestamp: new Date().toISOString(),
  //       }),
  //     );
  //   }, 1000);
  // };
  const updateLoan = (id, field, value) => {
    const loanIndex = loans.findIndex((l) => l.id === id) + 1; // loan_1, loan_2...

    setLoans((prevLoans) =>
      prevLoans.map((loan) =>
        loan.id === id ? { ...loan, [field]: value } : loan,
      ),
    );

    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id || value === "") return;

    const key = `${id}_${field}`;

    if (debounceRef.current[key]) {
      clearTimeout(debounceRef.current[key]);
    }

    debounceRef.current[key] = setTimeout(() => {
      const isNumberField = ["interestRate", "balance", "minPayment"].includes(field);

      dispatch(
        calculatorAnalytics({
          calculator_type: "student_loan",
          event_type: "input_adjusted",
          loan_name: `loan_${loanIndex}`,
          input_name: field.replace(/[A-Z]/g, (l) => `_${l.toLowerCase()}`),
          inputs: isNumberField ? parseFloat(value) : value.trim(),
          results_viewed: true,
          session_id,
          timestamp: new Date().toISOString(),
        })
      );
    }, 1000);
  };
  const calculatePayoff = () => {
    const validLoans = loans.filter(
      (l) =>
        l.balance &&
        l.interestRate &&
        l.minPayment &&
        parseFloat(l.balance) > 0 &&
        parseFloat(l.interestRate) > 0 &&
        parseFloat(l.minPayment) > 0,
    );

    if (validLoans.length === 0) {
      setResults(null);
      return;
    }

    // Sort loans by balance (smallest to largest) for debt snowball
    const sortedLoans = [...validLoans].sort(
      (a, b) => parseFloat(a.balance) - parseFloat(b.balance),
    );

    // Calculate minimum payment only scenario
    let minimumMonths = 0;
    let minimumInterest = 0;

    validLoans.forEach((loan) => {
      const principal = parseFloat(loan.balance);
      const monthlyRate = parseFloat(loan.interestRate) / 100 / 12;
      const payment = parseFloat(loan.minPayment);

      let remaining = principal;
      let months = 0;
      let totalInterest = 0;

      while (remaining > 0 && months < 600) {
        const interestCharge = remaining * monthlyRate;
        totalInterest += interestCharge;
        const principalPayment = payment - interestCharge;

        if (principalPayment <= 0) {
          months = 600;
          break;
        }

        remaining -= principalPayment;
        if (remaining < 0) remaining = 0;
        months++;
      }

      minimumMonths = Math.max(minimumMonths, months);
      minimumInterest += totalInterest;
    });

    // Calculate debt snowball with extra payment
    const extra = parseFloat(extraPayment) || 0;
    let snowballMonths = 0;
    let snowballInterest = 0;
    let totalMinPayment = validLoans.reduce(
      (sum, l) => sum + parseFloat(l.minPayment),
      0,
    );

    let freedUpPayment = 0;

    sortedLoans.forEach((loan, index) => {
      const principal = parseFloat(loan.balance);
      const monthlyRate = parseFloat(loan.interestRate) / 100 / 12;
      const loanMinPayment = parseFloat(loan.minPayment);

      // Current available payment is this loan's minimum + any freed up payments + extra
      const availablePayment = loanMinPayment + freedUpPayment + extra;

      let remaining = principal;
      let months = 0;
      let totalInterest = 0;

      while (remaining > 0 && months < 600) {
        const interestCharge = remaining * monthlyRate;
        totalInterest += interestCharge;
        const principalPayment = Math.min(
          availablePayment - interestCharge,
          remaining,
        );

        if (principalPayment <= 0) {
          months = 600;
          break;
        }

        remaining -= principalPayment;
        if (remaining < 0.01) remaining = 0;
        months++;
      }

      snowballMonths += months;
      snowballInterest += totalInterest;

      // After this loan is paid off, free up its minimum payment for the next loan
      freedUpPayment += loanMinPayment;
    });

    const totalBalance = validLoans.reduce(
      (sum, l) => sum + parseFloat(l.balance),
      0,
    );
    const totalMinPayments = validLoans.reduce(
      (sum, l) => sum + parseFloat(l.minPayment),
      0,
    );

    setResults({
      totalBalance,
      totalMinPayments,
      minimum: {
        months: minimumMonths,
        years: Math.floor(minimumMonths / 12),
        remainingMonths: minimumMonths % 12,
        totalInterest: minimumInterest,
        totalPaid: totalBalance + minimumInterest,
      },
      snowball: {
        months: snowballMonths,
        years: Math.floor(snowballMonths / 12),
        remainingMonths: snowballMonths % 12,
        totalInterest: snowballInterest,
        totalPaid: totalBalance + snowballInterest,
        monthsSaved: minimumMonths - snowballMonths,
        interestSaved: minimumInterest - snowballInterest,
      },
    });
  };

  useEffect(() => {
    calculatePayoff();
  }, [loans, extraPayment]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const getPayoffDate = (months) => {
    const date = new Date();
    date.setMonth(date.getMonth() + months);
    return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  };

  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem("comparison_session_id");
      sessionStorage.removeItem("session_expiry");

      console.log("🧹 Session cleared on logout");
    }
  }, [user]);
  useEffect(() => {
    if (!user?.id) return;

    const existingSession = sessionStorage.getItem("comparison_session_id");
    const expiry = sessionStorage.getItem("session_expiry");

    // 🔥 Check if valid session exists
    if (existingSession && expiry && Date.now() < Number(expiry)) {
      
      return;
    }

    // const token = localStorage.getItem("authToken");

    // dispatch(
    //   sessionId({
    //     user_id: user.id,
    //     access_token: token,
    //   }),
    dispatch(sessionId()).then((res) => {
      const data = res.payload?.data;

      if (data?.session_id) {
        sessionStorage.setItem("comparison_session_id", data.session_id);

        // 🔥 store expiry (important)
        const expiryTime = Date.now() + data.expires_in * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);

        
      }
    });
  }, [user]);
  useEffect(() => {
    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id) return;

    dispatch(
      calculatorAnalytics({
        calculator_type: "student_loan",
        event_type: "student_loan_snowball_method_view",
        session_id,
        timestamp: new Date().toISOString(),
      }),
    );
  }, [dispatch]);
  return (
    <div className="student-loan-content">
      <div className="app-page-title">
        <div className="page-title-heading">
          <h3 className="page-title">Student Loan</h3>
        </div>
      </div>
      <Card className="p-0">
        <Card.Body>
          <div className="header-banner">
            <h4>Student Loan Payoff Calculator</h4>
            <p>
              Find out how long it will take to pay off your student loans—and
              how you can save yourself time (and interest) by boosting your
              monthly payment.
            </p>
          </div>
        </Card.Body>
      </Card>
      <div className="filters-content-main">
        <Row className="mb-3">
          <div className="filter-content">
            {/* Your Student Loans Section */}
            <Card>
              <CardBody>
                <div className="inner-sub-sub-title student-loan-header">
                  <div className="inner-sub-title">Your Student Loans</div>
                </div>

                <div className="loan-component">
                  {loans.map((loan, index) => (
                    <div key={loan.id} className="loan">
                      <div className="count-remove-btn">
                        <div className="loan-count">
                          Student Loan {index + 1}
                        </div>
                        {loans.length > 1 && (
                          <button
                            onClick={() => removeLoan(loan.id)}
                            className="remove-loan"
                            aria-label="Remove loan"
                          >
                            <Trash2 className="w-5 h-5 icon" />
                          </button>
                        )}
                      </div>
                      <div class="row form-row">
                        <div className="col-6 cols">
                          <div class="formgroup">
                            <label className="col-label">Interest Rate</label>
                            <div class="input-wrapper">
                              <span class="prefix">%</span>
                              <input
                                type="number"
                                step="0.01"
                                value={loan.interestRate}
                                onChange={(e) =>
                                  updateLoan(
                                    loan.id,
                                    "interestRate",
                                    e.target.value,
                                  )
                                }
                                placeholder="0"
                                className="col-input"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6 cols">
                          <div class="formgroup">
                            <label className="col-label">Balance</label>
                            <div class="input-wrapper">
                              <span class="prefix">$</span>
                              <input
                                type="number"
                                value={loan.balance}
                                onChange={(e) =>
                                  updateLoan(loan.id, "balance", e.target.value)
                                }
                                placeholder="0"
                                className="col-input"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6 cols">
                          <div class="formgroup">
                            <label className="col-label">Minimum Payment</label>
                            <div class="input-wrapper">
                              <span class="prefix">$</span>
                              <input
                                type="number"
                                value={loan.minPayment}
                                onChange={(e) =>
                                  updateLoan(
                                    loan.id,
                                    "minPayment",
                                    e.target.value,
                                  )
                                }
                                placeholder="0"
                                className="col-input"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6 cols">
                          <div class="formgroup">
                            <label className="col-label">
                              Account Name
                              <span class="optional">(Optional)</span>
                            </label>
                            <div class="input-wrapper without-prefix">
                              <input
                                type="text"
                                value={loan.accountName}
                                onChange={(e) =>
                                  updateLoan(
                                    loan.id,
                                    "accountName",
                                    e.target.value,
                                  )
                                }
                                placeholder="Lender Name"
                                className="col-input"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div class="buttons text-center p-0">
                    <button onClick={addLoan} class="add-debt btn btn-primary">
                      <Plus className="m-0 me-1" /> Add Debt
                    </button>
                  </div>
                </div>
              </CardBody>
            </Card>

            {/* Your Household Income Section */}

            <Card>
              <CardBody>
                <div className="inner-sub-sub-title student-loan-header">
                  <div className="inner-sub-title">Your Household Income</div>
                </div>

                <div className="income-card">
                  <p className="income-desc">
                    This includes <strong>any income</strong> you make each
                    month after taxes (your paycheck, your side hustle—it all
                    counts).
                  </p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="formgroup mb-0">
                        <label className="col-label">
                          Monthly Household Income <span>(Optional)</span>
                        </label>

                        <div className="input-wrapper">
                          <span className="currency prefix">$</span>
                          <input
                            type="number"
                            value={householdIncome}
                            onChange={(e) => setHouseholdIncome(e.target.value)}
                            placeholder="0"
                            className="col-input"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>

            {/* Additional Payment Section */}

            <Card className="mb-0">
              <CardBody>
                <div className="inner-sub-sub-title student-loan-header">
                  <div className="inner-sub-title">Additional Payment</div>
                </div>

                <div className="payment-card">
                  <p className="payment-desc">
                    Next, to snowball your debt, enter the{" "}
                    <strong>additional amount</strong> you want to pay above the
                    minimum required payment.
                  </p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="formgroup mb-0">
                        <label className="col-label">
                          Extra Monthly Payment <span>(Optional)</span>
                        </label>

                        <div className="input-wrapper">
                          <span className="currency prefix">$</span>
                          <input
                            type="number"
                            value={extraPayment}
                            // onChange={(e) => setExtraPayment(e.target.value)}
                            onChange={(e) => {
                              const value = e.target.value;
                              setExtraPayment(value);

                              const session_id = sessionStorage.getItem(
                                "comparison_session_id",
                              );
                              if (!session_id || value === "") return;

                              const key = "extra_payment";

                              if (debounceRef.current[key]) {
                                clearTimeout(debounceRef.current[key]);
                              }

                              debounceRef.current[key] = setTimeout(() => {
                                dispatch(
                                  calculatorAnalytics({
                                    calculator_type: "student_loan",
                                    event_type: "input_adjusted",
                                    input_name: "extra_payment",
                                    inputs: Number(value),
                                    results_viewed: true,
                                    session_id,
                                    timestamp: new Date().toISOString(),
                                  }),
                                );
                              }, 1000);
                            }}
                            placeholder="0"
                            className="col-input"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <button
                          onClick={calculatePayoff}
                          className="payment-button"
                        >
                          Get Your Debt-Free Date
                        </button> */}
                </div>
              </CardBody>
            </Card>
          </div>

          <div className="filter-sidebar m-0">
            <Card className="filter-container mb-0">
              <div className="results-wrapper">
                <div className="inner-sub-sub-title student-loan-header">
                  <div className="inner-sub-title">Your Debt-Free Date</div>
                </div>

                {results ? (
                  <div className="results-content">
                    <p className="results-subtext">
                      If you continue making only minimum payments, you'll be
                      debt-free
                    </p>

                    <div className="results-date">
                      <div className="date-main">
                        {getPayoffDate(results.minimum.months)}
                      </div>
                      {/*  mt-1 */}
                      <div className="date-sub">
                        ({results.minimum.years}{" "}
                        {results.minimum.years === 1 ? "year" : "years"} and{" "}
                        {results.minimum.remainingMonths}{" "}
                        {results.minimum.remainingMonths === 1
                          ? "month"
                          : "months"}
                        )
                      </div>
                    </div>

                    <div className="results-grid">
                      <div className="item">
                        <span>Total Debt</span>
                        <strong>{formatCurrency(results.totalBalance)}</strong>
                      </div>
                      <div className="item">
                        <span>Total Interest</span>
                        <strong className="danger">
                          {formatCurrency(results.minimum.totalInterest)}
                        </strong>
                      </div>
                    </div>

                    <div className="results-total pb-0">
                      <span>Total you'll pay</span>
                      <strong>
                        {formatCurrency(results.minimum.totalPaid)}
                      </strong>
                    </div>

                    {results.snowball.monthsSaved > 0 && (
                      <>
                        <div className="snowball-section">
                          <div className="inner-sub-sub-title student-loan-header">
                            <div className="inner-sub-title">
                              With Smart Payoff Strategy
                            </div>
                          </div>
                          <p>
                            By using the Smart Payoff Strategy
                            {extraPayment &&
                              ` and paying an extra ${formatCurrency(
                                parseFloat(extraPayment),
                              )} per month`}
                            , you'll be debt-free
                          </p>

                          <div className="results-date snowball">
                            <div className="date-main blue">
                              {getPayoffDate(results.snowball.months)}
                            </div>
                            <div className="date-sub mt-1">
                              ({results.snowball.years}{" "}
                              {results.snowball.years === 1 ? "year" : "years"}{" "}
                              and {results.snowball.remainingMonths}{" "}
                              {results.snowball.remainingMonths === 1
                                ? "month"
                                : "months"}
                              )
                            </div>
                          </div>

                          <div className="savings-box">
                            <span>You'll Save:</span>
                            <strong>
                              {Math.floor(results.snowball.monthsSaved / 12)}{" "}
                              years and {results.snowball.monthsSaved % 12}{" "}
                              months
                            </strong>
                            <div>
                              {formatCurrency(results.snowball.interestSaved)}{" "}
                              in interest
                            </div>
                          </div>

                          <div className="results-grid">
                            <div className="item">
                              <span>Total Interest</span>
                              <strong className="danger">
                                {formatCurrency(results.snowball.totalInterest)}
                              </strong>
                            </div>
                            <div className="item">
                              <span>Total you'll pay</span>
                              <strong>
                                {formatCurrency(results.snowball.totalPaid)}
                              </strong>
                            </div>
                          </div>
                        </div>

                        <div className="info-box">
                          <strong>Important:</strong> When making extra
                          payments, tell your loan servicer to apply the extra
                          amount toward the <strong>principal balance</strong>,
                          not future payments.
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="results-placeholder">
                    <p>
                      If you continue making only minimum payments,
                      <br /> you'll be debt-free
                    </p>
                    <div className="skeleton lg"></div>
                    <div className="skeleton sm"></div>
                  </div>
                )}
              </div>
            </Card>
          </div>
        </Row>

        <Card className="snowball-card">
          <CardBody>
            <div className="inner-sub-sub-title student-loan-header">
              <div className="inner-sub-title">
                How the Smart Payoff Strategy Works
              </div>
            </div>

            <div className="snowball-steps">
              <div className="row">
                <div className="col-sm-4 cols">
                  <div className="snowball-step">
                    <div className="step-number">1</div>
                    <h3 className="step-title">List Your Debts</h3>
                    <p className="step-desc">
                      List all debts from smallest to largest balance,
                      regardless of interest rate.
                    </p>
                  </div>
                </div>

                <div className="col-sm-4 cols">
                  <div className="snowball-step">
                    <div className="step-number">2</div>
                    <h3 className="step-title">Attack the Smallest</h3>
                    <p className="step-desc">
                      Make minimum payments on everything except the smallest
                      debt. Attack it with everything you've got.
                    </p>
                  </div>
                </div>

                <div className="col-sm-4 cols">
                  <div className="snowball-step">
                    <div className="step-number">3</div>
                    <h3 className="step-title">Roll It Forward</h3>
                    <p className="step-desc">
                      Once paid off, take that payment and roll it to the next
                      smallest debt. Repeat until debt-free!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
